import React from "react";

export default function ServicesOverview() {
  return (
    <section id="services" class="py-5 bg-white">
      <div class="container py-5">
        <div class="section-title">
          <h2 class="mb-3">Green Card & Citizenship</h2>
          <p>Confidently Navigate The Process</p>
        </div>

        <div className="row g-4">
          <div className="col-md-4 d-flex">
            <div className="service-card greencard-service animate-on-scroll d-flex flex-column w-100">
              <i className="fas fa-id-card service-icon greencard-icon"></i>
              <h3>Green Card Renewal</h3>
              <p>Renew or replace your Permanent Resident Card</p>
              <ul className="mt-3">
                <li><span style={{fontWeight:'bold'}}>Form I-90</span> preparation</li>
                <li>Document checklist</li>
                <li>Case tracking</li>
                <li>Replacement services</li>
              </ul>
              <a
                href="#greencard"
                className="btn learnmore-blue mt-auto"
                aria-label="learn"
              >
                Learn More
              </a>
            </div>
          </div>

          <div className="col-md-4 d-flex">
            <div className="service-card family-service animate-on-scroll d-flex flex-column w-100">
              <i className="fas fa-users service-icon family-icon"></i>
              <h3>Family-Based Green Card</h3>
              <p>Bring your family members to the United States</p>
              <ul className="mt-3">
                <li>Spouse applications</li>
                <li>Parent petitions</li>
                <li>Sibling petitions</li>
                <li>Child applications</li>
              </ul>
              <a
                href="#family"
                className="btn learnmore-red mt-auto"
                aria-label="learn"
              >
                Learn More
              </a>
            </div>
          </div>

          <div className="col-md-4 d-flex">
            <div className="service-card citizenship-service animate-on-scroll d-flex flex-column w-100">
              <i className="fas fa-flag-usa service-icon citizenship-icon"></i>
              <h3>Citizenship & Naturalization</h3>
              <p>Comprehensive services to become US citizen</p>
              <ul className="mt-3">
                <li><span style={{fontWeight:'bold'}}>Form N-400</span> preparation</li>
                <li>Test preparation</li>
                <li>Interview coaching</li>
                <li>Application review</li>
              </ul>
              <a
                href="#citizenship"
                className="btn learnmore-purple mt-auto"
                aria-label="learn"
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
